import { ConvertToFloat, isValidArray } from "../../../Layout/Common/common";

export const PriceBreakup = ({ priceDetails }) => {
  return (
    <div className="pricingDetails-dropdown pricingDetails-dropdown-order mt-2 mt-sm-3">
      <div className="pricingDetails-header">
        <div className="cost-ex">Cost Ex</div>
        <div className="cost-ex">Qty</div>
      </div>
      <div className="pricingDetails-content">
        {isValidArray(priceDetails) &&
          priceDetails.map((detail, index) => (
            <div className="pricingDetails-content-list" key={index}>
              <div className="price-ex">{`$${ConvertToFloat(detail.price2)}`}</div>
              <div className="price-ex">{detail.qty}</div>
            </div>
          ))}
      </div>
    </div>
  );
};
